import React from 'react';

export default function WarningIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1 8.16699C1 12.033 4.13401 15.167 8 15.167C11.866 15.167 15 12.033 15 8.16699C15 4.301 11.866 1.16699 8 1.16699C4.13401 1.16699 1 4.301 1 8.16699ZM2 8.16699C2 4.85328 4.68629 2.16699 8 2.16699C11.3137 2.16699 14 4.85328 14 8.16699C14 11.4807 11.3137 14.167 8 14.167C4.68629 14.167 2 11.4807 2 8.16699ZM8.5 11.0003V6.50033H6.5V7.50033H7.5V11.0003H6V12.0003H10V11.0003H8.5ZM7.25 4.25033C7.25 3.83611 7.58579 3.50033 8 3.50033C8.41421 3.50033 8.75 3.83611 8.75 4.25033C8.75 4.66454 8.41421 5.00033 8 5.00033C7.58579 5.00033 7.25 4.66454 7.25 4.25033Z"
                fill="#212529"
            />
        </svg>
    );
}
